var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-last-message-sidebar"},[_c('multi-message-editor-with-media-input',{staticClass:"mt-0",attrs:{"setup":{
      'func': _vm.setMessage,
      'args': {
        'model': _vm.node.data,
        'key': 'variants',
        'prefix': 'edit_last_message_sidebar_',
        'validation': 'required',
        'pinButtons': true,
        'availableButtonsTypes': _vm.node.nodeProps.availableButtonsTypes,
        'hasMedia': true,
        'buttonsHelpView': _vm.node.nodeProps.buttonHelpView,
        'placeholders': _vm.placeholders,
        'targetToUpload': {
          'target': 'target',
          'target_id': _vm.node.nodeProps.target,
        },
        'settingsStructure': {
          'pin': false,
          'disable_link_preview': false,
          'disable_notify': false,
          'remove_previous': false,
          'protect_content': false,
          'remove_after': 0,
        },
        'customMediaTypes': _vm.node.nodeProps.customMediaTypes,
      }
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }